<template>
	<div class="matters_list">
    <tab-list
    setHeadBtn
    ref="multipleTable"
    tabHeight="310"
    :selectedList="selectedList"
    :tabList="listArr"
    :total="total"
    :pages="pages"
    :fromData="fromData"
    :columns="tabColumns"
    tabName="matters-checkStockList-list"
    @getSelect="getSelect"
    @currentChange="currentChange"
    @changePages="changePages"
    @selectSdata="selectSdata">
    </tab-list> 
	</div>
</template>
<script>
import {saleOutStock} from 'api/stock.js';
import tabList from 'components/table/list.vue';
import searchBox from 'components/common/search.vue';
export default{
  components:{
    tabList,searchBox
  },
  props:{
  	//已选列表,未添加到数据库
  	selectedList:Array,
    searchCriteria:Object,//搜索条件
  },
	data(){
		return{
			sdata:{},
			listArr:[],//列表
			tabColumns:[
        {field: 'projectClassify', title: '项目', width:100,"sortable":true},
        {field: 'bomComponent', title: '组件'},
			  {field: 'bomComponentDesc', title: '组件描述'},
			  {field: 'componentNum', title: '需求数量'},
			  {field: 'availStock', title: '有效库存数量'},
        {field: 'shortQuantity', title: '短缺数量'},
        {field: 'compUnitDesc', title: '基本计量单位'},
				{field: 'inventoryDesc', title: '库存地点'},
      ],//表头字段
			isDelList:false,//是否显示已删除的
			total:0,//总条数
			pages:0,//总页数
			fromData:{
				page:1,//当前页
				pageSize:10,//每页显示的数量,
				searchCriteria:this.searchCriteria
			}
		}
	},
	watch:{
		//监听选择的变化
    selectedList:{
      handler:function(newVal){
        if(this.selectedList.length != newVal.length){
          this.getList();
        }
      },
      deep:true
    },
    fromData:{
      handler:function(){
        console.log(11,'条件改变');
        this.getList();
      },
      deep:true
    }
	},
	created(){
		this.getList();
	},
	methods:{
    //取消选择
    cancelSelect(){
      this.$refs.multipleTable.cancelSelect();
    },
    //获取已选
    getSelect(res){
      this.$emit('getSelect',res);
    },
    //选中数据
    selectSdata(data){
      this.sdata = data;
    },
		//初始化需要获取的数据
		async getList(){
      console.log(this.$store.state.cache.CheckBomList)
       this.listArr = this.$store.state.cache.CheckBomList
       
		},
		//当前页码改变
		currentChange(currentPage){
			this.fromData.page = currentPage;
			this.getList();
		},
    //页码条数改变
    changePages(pages){
      this.fromData.page = 1;
      this.fromData.pageSize = pages;
      this.getList();
    },
		handleSelectChange(item,key){
			if(item.isLock) return false;
			if(item.isChecked){
				item.isChecked = false;
				this.selectList.splice(key,1);
			}else{
				item.isChecked = true;
				this.selectList.push(item);
			}
		}
	}
}
</script>

<style>
</style>
